/**
 * 任务修改仓位权限相关字段，来自
 * https://liaofeng.feishu.cn/sheets/shtcnZwEnu3NxrS22N9Onqwtuzb?sheet=a1f812
 */

/**
 * 任务修改仓位
 */
export const Read = 'wms_change_position_get';
